import React from "react";

export default function Logo({ compact = false, className = "" }) {
  if (compact) {
    return (
      <div className={`flex items-center gap-2 select-none ${className}`} data-testid="brand-logo">
        <div className="w-9 h-9 rounded-xl bg-[#FF5500] flex items-center justify-center shadow-[0_4px_16px_rgba(255,85,0,0.4)]">
          <span className="font-display font-black text-white text-lg leading-none">G</span>
        </div>
      </div>
    );
  }
  return (
    <div className={`flex items-center select-none ${className}`} data-testid="brand-logo">
      <img src="/getupfit-logo.png" alt="Get Up Fit" className="h-12 w-auto object-contain drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)]" />
    </div>
  );
}
